import { gql } from 'apollo-boost';

export const SUBMIT_AI_CHAT_MESSAGE_FEEDBACK = gql`
    mutation($data: SubmitAiChatMessageFeedbackInput!) {
        submitAiChatMessageFeedback(data: $data)
    }
`;
